// extracted by mini-css-extract-plugin
export default {"wrapper":"link_wrapper__kVnuP","text":"link_text__qZI7v","icon":"link_icon__Sxoxh"};